import { Link } from "react-router-dom";
import "./Footer.css";

function Footer({ transparent }) {

    return (

        <div className={`app-footer ${transparent ? "app-footer-transparent" : ""}`}>

            <div className="app-footer-line">
                &copy; 2026 Kinetiq Robotics Private Limited (KRPL). All rights reserved.
                <span className="app-footer-divider">|</span>
                Empowering automation through intelligent engineering.
            </div>

            <div className="app-footer-links">

                <Link to="/privacy-policy">Privacy Policy</Link>

                <span className="app-footer-divider">|</span>

                <Link to="/terms-of-service">Terms of Service</Link>

                <span className="app-footer-divider">|</span>

                <Link to="/cookie-preferences">Cookie Preferences</Link>

                <span className="app-footer-divider">|</span>

                <Link to="/contact-support">Contact Support</Link>

            </div>

        </div>

    );

}

export default Footer;
